module.exports = __webpack_public_path__ + "static/media/tessa_creme.6e4a5ce0.svg";